
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IAuthState } from "./types";

const initialState: IAuthState = {
  accessToken: null,
  phone: null,
  authData: null,
  restoreTimer: 0,
  codeTimer: 0,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setToken: (state, action: PayloadAction<string | null>) => {
      state.accessToken = action.payload;
    },
    setPhoneData: (state, action: PayloadAction<string | null>) => {
      state.phone = action.payload;
    },
    setAuthData: (state, action: PayloadAction<any>) => {
      state.authData = action.payload;
    },
    setRestoreTimer: (state, action: PayloadAction<number>) => {
      state.restoreTimer = action.payload;
    },
    setCodeTimer: (state, action: PayloadAction<number>) => {
      state.codeTimer = action.payload;
    },
    decrementRestoreTimer: (state) => {
      if (state.restoreTimer > 0) {
        state.restoreTimer -= 1;
      }
    },
    decrementCodeTimer: (state) => {
      if (state.codeTimer > 0) {
        state.codeTimer -= 1;
      }
    },
    clearAuthData: (state) => {
      state.accessToken = null;
      state.phone = null;
      state.authData = null;
      state.restoreTimer = 0;
      state.codeTimer = 0;
    },
  },
});

export const {
  setToken,
  setPhoneData,
  setAuthData,
  setRestoreTimer,
  setCodeTimer,
  decrementRestoreTimer,
  decrementCodeTimer,
  clearAuthData,
} = authSlice.actions;

export default authSlice.reducer;

